import React, { useContext } from 'react'
import { Route, RouteProps, Redirect } from 'react-router-dom'
import { LoadingSpinner } from './components/ui/LoadingSpinner'
import { AuthenticationContext } from './Contexts/AuthenticationProvider'
import { routes } from './routes'

type Props = RouteProps
export const PrivateRoute: React.FC<Props> = ({ children, ...routeProps }) => {
  const authCtx = useContext(AuthenticationContext)
  return authCtx && authCtx.loadingActor ? (
    <LoadingSpinner />
  ) : (
    <Route
      {...routeProps}
      render={() =>
        authCtx && authCtx.actor && authCtx.actor.id ? (
          children
        ) : (
          <Redirect to={routes.login.makeUrl()} />
        )
      }
    />
  )
}
